/**
 * Stamp the page CSP nonce onto every document.createElement("style").
 * Must load before any library injects a <style> tag (e.g. react-fast-marquee).
 * Those injectors have no nonce prop; without this, style-src nonce enforcement
 * blocks their CSS and duplicated marquee content becomes visible.
 */
(function stampNonceOnInjectedStyles() {
  if (typeof document === "undefined") return;

  const nonce =
    document.querySelector('meta[property="csp-nonce"]')?.getAttribute("content") ||
    document.documentElement.getAttribute("data-csp-nonce") ||
    "";

  if (!nonce || nonce === "__CSP_NONCE__") return;

  const origCreate = document.createElement.bind(document);
  document.createElement = function (tag, ...args) {
    const el = origCreate(tag, ...args);
    if (String(tag).toLowerCase() === "style") {
      el.setAttribute("nonce", nonce);
    }
    return el;
  };
})();
